import {
  GET_ALL_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_SUCCESS,
  GET_ALL_CATEGORY_FAILURE,
  GET_ALL_SUBCATEGORY_REQUEST,
  GET_ALL_SUBCATEGORY_SUCCESS,
  GET_ALL_SUBCATEGORY_FAILURE,
  GET_ALL_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_SUCCESS,
  GET_ALL_PRODUCTCATEGORY_FAILURE,
} from "./ActionType";

const initialState = {
  categories: [],
  subCategories:[],
  productCategories:[],
  loading: false,
  error: "",
};

export const publicCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_ALL_CATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_CATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", categories: action.payload };

    case GET_ALL_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case GET_ALL_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SUBCATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", subCategories: action.payload };

    case GET_ALL_SUBCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case GET_ALL_PRODUCTCATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PRODUCTCATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", productCategories: action.payload };

    case GET_ALL_PRODUCTCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
